import { useEffect, useState } from 'react';
import { AssignmentCategory } from '../../../constants/types/student/homework/type';
import { myLearingInfoDetailType } from '../../../constants/types/student-type';
import { getCourseConfig } from '../../../api/utils/lms/utils';

export const useAssignmentCategory = (classDetail: myLearingInfoDetailType) => {
  const classType: AssignmentCategory =
    getCourseConfig(classDetail?.course.id)?.assignmentCategory ?? 'NONE';

  const [selectedCategory, setSelectedCategory] =
    useState<AssignmentCategory>('NONE');

  useEffect(() => {
    setSelectedCategory(classType);
  }, [classType]);

  const onCategoryChange = (category: AssignmentCategory) => {
    setSelectedCategory(category);
  };

  return {
    classType,
    selectedCategory,
    onCategoryChange,
  };
};
